module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5QIpC"))).then(() => parcelRequire('45EB9'));